/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
export function debugPrint(message) {
    var optionalParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        optionalParams[_i - 1] = arguments[_i];
    }
    console.log("".concat(message), optionalParams);
}
